import React, { useEffect, useState } from "react";
import FreshChat from "./FreshChat";
import RecentComments from "./RecentComments";
import ActivityLog from "./ActivityLog";
import CustomerProfile from "./CustomerProfile";
import CardTabs from "modules/common/card-tabs/CardTabs";
import SendComment from "./SendComment";
import Booking from "./Booking";
import TicketHistory from "./TicketHistory";
import UploadDocuments from "./UploadDocumnets";
import Orders from "./Orders";
import SideSubTab from "./SideSubTab";
import RecommendationSideSubTab from "./RecommendationSideSubTab"
import ExpectationSettings from "./ExpectationSettings";
import EngagementResponse from "./EngagementResponse";
import OldEngagementResponse from "./OldEngagementResponse";
import CustomerFeedbackLead from "./CustomerFeedbackLead";
import { useConsultFeedback } from "./store";

function SubTabs({ activeTab, setActiveTab, orders, ...props }) {
    const tabStyle = { height: "27.5rem" };
    const [comment, setComment] = useState("");
    const { fetchCaseResponses } = useConsultFeedback()

    useEffect(() => {
        fetchCaseResponses(props.customer.id);
    }, [props.booking, props.customer]);

    const tabs = {
        consult: (
            <SideSubTab
                customer={props.customer}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
        ),
        customerfeedback: (
            <CustomerFeedbackLead
                customer={props.customer}
                formNames={['activeCxO5plus','dropped_leads', 'd12FeedbackForm', 'kitStarted']}
            />
        ),
        "customer profile": (
            <div style={tabStyle}>
                <CustomerProfile
                    user={props.customer.user}
                    medrep={props.customer.assignment?.first_name}
                    setMessageFloater={props.setMessageFloater}
                    customer={props.customer}
                />
            </div>
        ),
        bookings: props.bookings && (
            <div style={tabStyle} className="scrollable-section">
                <Booking
                    customer={props.customer}
                    bookings={props.bookings}
                    setMessageFloater={props.setMessageFloater}
                />
            </div>
        ),
        orders: (
            <div style={tabStyle}>
                <Orders customer={orders} orders={props.customer.orders} />
            </div>
        ),
        "recent comments": (
            <div style={tabStyle} className="scrollable-section">
                <div
                    style={{ height: "24rem", overflowY: "scroll", width: "100%" }}
                    className="scrollable-section"
                >
                    <RecentComments
                        customer={props.customer}
                        setMessageFloater={props.setMessageFloater}
                    />
                </div>
                <SendComment
                    case_id={props.customer.id}
                    comment={comment}
                    setComment={setComment}
                />
            </div>
        ),
        "engagement response": (
            <div style={tabStyle} className="scrollable-section">
                <div
                    style={{ height: "24rem", overflowY: "scroll", width: "100%" }}
                    className="scrollable-section"
                >
                    <EngagementResponse
                        customer={props.customer}
                        setMessageFloater={props.setMessageFloater}
                    />
                </div>
            </div>
        ),
        "old engagement response": (
            <div style={tabStyle} className="scrollable-section">
                <div
                    style={{ height: "24rem", overflowY: "scroll", width: "100%" }}
                    className="scrollable-section"
                >
                    <OldEngagementResponse
                        customer={props.customer}
                        setMessageFloater={props.setMessageFloater}
                    />
                </div>
            </div>
        ),
        "chats from freshchat": (
            <div style={tabStyle}>
                <FreshChat
                    customer={props.customer}
                    setMessageFloater={props.setMessageFloater}
                />
            </div>
        ),
        "expectation setting": (
            <div style={tabStyle}>
                <ExpectationSettings
                    case_id={props.customer.id}
                />
            </div>
        ),
        "activity logs": (
            <div style={tabStyle} className="scrollable-section">
                <ActivityLog
                    customer={props.customer}
                    setMessageFloater={props.setMessageFloater}
                />
            </div>
        ),
        "ticket history": (
            <div style={tabStyle} className="scrollable-section">
                <TicketHistory
                    customer={props.customer}
                    setMessageFloater={props.setMessageFloater}
                />
            </div>
        ),
        "upload documents": (
            <div style={tabStyle} className="scrollable-section">
                <UploadDocuments
                    setMessageFloater={props.setMessageFloater}
                    case_id={props.customer.id}
                />
            </div>
        ),
        "recommendation feedback form": (
            <div style={tabStyle} className="scrollable-section">
                <RecommendationSideSubTab
                    customer={props.customer}
                    setMessageFloater={props.setMessageFloater}
                    case_id={props.customer.id}
                />
            </div>
        ),

    };
    return (
        <div>
            <CardTabs components={tabs} />
        </div>
    );
}

export default SubTabs;
